// extracted by mini-css-extract-plugin
module.exports = {"container":"_2S-PBduaqEBa-jQtf6ymaD","deleteBtnWrapper":"_2UnZuwL8zNJaecj29_bX83","deleteBtn":"_1WH1WWJ2K-sdCsgk-ORHYl","icon":"_1_3rOJegeiYnh4dC8pHP8v"};